import { render } from "./ProgressBarItem.vue?vue&type=template&id=72d1b0fb"
import script from "./ProgressBarItem.vue?vue&type=script&lang=js"
export * from "./ProgressBarItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/marina-brunello/lifetime/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__